<div class="contact-messages-container">

  <h2>پیام‌های دریافتی</h2>

  <!-- بخش بارگیری -->
  <div *ngIf="isLoading" class="loading-section">
    <i class="fas fa-spinner fa-spin loading-icon"></i>
    <span>در حال بارگیری پیام‌ها...</span>
  </div>

  <!-- بخش خطا -->
  <div *ngIf="errorMessage" class="error-section">
    <i class="fas fa-exclamation-triangle error-icon"></i>
    <span>{{ errorMessage }}</span>
  </div>

  <!-- جدول پیام‌ها -->
  <div *ngIf="!isLoading && !errorMessage" class="messages-table-wrapper">
    <table *ngIf="messages.length > 0" class="styled-table">
      <thead>
        <tr>
          <th>نام</th>
          <th>ایمیل</th>
          <th>پیام</th>
          <th>زمان دریافت</th>
          <th> عملیات</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let message of messages; let i = index">
          <td>{{ message.name }}</td>
          <td>{{ message.email }}</td>
          <td class="message-cell">
            <!-- نمایش بخشی از پیام یا همه پیام، بسته به نیاز -->
            {{ message.message }}
            <!-- اگر پیام‌ها خیلی طولانی هستن، می‌تونید خلاصه نشون بدید -->
            <!-- <span *ngIf="message.message.length > 100">{{ message.message.substring(0, 100) }}...</span>
            <span *ngIf="message.message.length <= 100">{{ message.message }}</span> -->
          </td>
          <td>{{ message.timestamp | date:'medium' }}</td>

          <td>
            <!-- دکمه ها در یک div قرار گرفتند و راست چین شدند -->
            <!-- <div class="d-flex justify-content-end flex-wrap" style="gap: 0.5rem;"> -->

              <button
                class="btn btn-danger btn-sm"
                (click)="delete(message.id)"
              >
                🗑 حذف
              </button>
            <!-- </div> -->
          </td>
        </tr>
      </tbody>
    </table>

    <!-- پیام برای زمانی که هیچ پیامی نیست -->
    <div *ngIf="messages.length === 0" class="no-messages">
      <i class="fas fa-inbox empty-inbox-icon"></i>
      <span>هیچ پیام تماسی دریافت نشده است.</span>
    </div>
  </div>

</div>
